import { types } from "../types/types";

const initialState =[]

export const sellReducer = ( state = initialState, action ) =>{

//    console.log(action.payload)
    switch ( action.type ) {

        case types.sellAddNew:
            return [
                ...state,
                {...action.payload}
            ]

        case types.sellLoaded:
            return [...action.payload]

        case types.sellUpdate:
            return [...state].map(
                    sell => (sell.id === action.payload.id) ? action.payload : sell
                )
        
        case types.sellDelete:
            return [...state].filter(
                sell => (sell.id !== action.payload.id)
            )


        default:
           return state ;
    }

};